import { useEffect, useState } from 'react';
import { toast } from '../../util/toasts';
import { CustomerProduct } from '../../clients/customer-api/product/customer-product';
import { useCustomer } from '../../hooks/use-customer-context';
import { CustomerTagPricing } from '../../clients/customer-api/customer/customer-customer';

export const parseTagDiscount = (tagPricing: CustomerTagPricing) => {
  return parseFloat(tagPricing.discount.toString()) / 100;
};

const doesTagContainProductCategory = (tagPricing: CustomerTagPricing, product: CustomerProduct) => {
  if (tagPricing.categoryIds?.length) {
    if (product.categoryIds && product.categoryIds?.some((c) => tagPricing.categoryIds!.includes(c))) {
      return true;
    }
  }
  return false;
};

const doesTagContainProduct = (tagPricing: CustomerTagPricing, product: CustomerProduct) => {
  if (tagPricing.productIds?.length) {
    if (product.id && tagPricing.productIds!.includes(product.id)) {
      return true;
    }
  }
};

export const isProductEligibleForTagDiscount = (tagPricing: CustomerTagPricing, product: CustomerProduct) => {
  if (!tagPricing.productIds?.length && !tagPricing.categoryIds?.length) {
    return true;
  }

  if (doesTagContainProduct(tagPricing, product) || doesTagContainProductCategory(tagPricing, product)) {
    return true;
  }

  return false;
};

export const useTagDiscount = (product: CustomerProduct | undefined) => {
  const customer = useCustomer();

  const [tagDiscount, setTagDiscount] = useState<number>(1);

  useEffect(() => {
    const fetchTagDiscount = async () => {
      if (!product || !customer?.id) {
        return;
      }
      try {
        if (customer?.id) {
          const tagPricing = customer?.tagPricing;
          if (tagPricing) {
            const parsedTag = parseTagDiscount(tagPricing);
            if (isProductEligibleForTagDiscount(tagPricing, product)) {
              setTagDiscount(1 - parsedTag);
            } else {
              setTagDiscount(1);
            }
          }
        }
      } catch {
        toast('Failed to fetch tag discount', 'error');
      }
    };

    fetchTagDiscount();
  }, [customer?.id, product]);

  return { tagDiscount };
};
